module.exports = __webpack_public_path__ + "img/quizz-step-3-1.dea2b7c6.jpg";